export default {
  page: '首页',
  system: '系统管理',
  userAdmin: '账号管理',
  userList: '账号列表',
  userName: '用户名称',
  userPass: '密码',
  email: '邮箱',
  userPhone: '用户手机',
  userType: '账号类型',
  selectuserType: '选择账号类型',
  createAcct: '更新人',
  makeupAmountLimit: '可用补单余额',
  createTime: '更新时间',
  userState: '账号状态',
  operation: '操作',
  addUser: '添加用户',
  inputtext: '请输入金额',
  inactive: '禁用',
  active: '启用',
  cancel: '取 消',
  confirm: '确 定',
  changePass: '修改密码',
  roleName: '角色',
  selectbank:'请选择银行',

  checkKey: '查看密钥',
  resetPass: '重置支付密码',
  resetSignPass: '重置登陆密码',
  oblPass: '原密码',
  newPass: '新密码',
  addFormName: '请输入用户名，用户名不能为空',
  addFormPass: '请输入密码，密码不能为空',
  addFormId: '请输入id',
  addFormType: '请输入账号类型',
  addFormPhone: '请输入手机号，手机号不能为空！',
  addFormEmail: '请输入邮箱，邮箱不能为空！',
  Administrator: '管理员',
  Agency: '代理',
  Commercial: '商户',
  addrefError: '参数不合法',
  changerefError: '参数不合法或新密码和原密码相同！',
  checkPassErr: '请输入正确的密码，由6-25位的字符组成',
  checkNameErr: '合法用户名由4-20位的数字和字母组成',
  checkEmailErr: '请输入合法邮箱，例：wangyi@163.com',
  checkPhoneErr: '请输入合法手机号，例：0-3(5,7,8,9)-00000000',
  hintmessage: '是否重置该用户的密码为123456',
  electwellattype: '选择钱包类型',
  refreshCacheHint:'是否刷新缓存'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/accountmanager.js